import React, { Component } from 'react';

export default class InstagramSvg extends Component {
  render() {
    return (
      <svg
        fill={this.props.color}
        viewBox="0 0 512 512"
        style={{ width: this.props.size, height: this.props.size, margin: 10 }}
      >
        <g transform="translate(1 1)">
          <path d="M365.08-1H144.92C64.707-1-1,64.707-1,144.92v220.16C-1,445.293,64.707,511,144.92,511h220.16 C445.293,511,511,445.293,511,365.08V144.92C511,64.707,445.293-1,365.08-1z M493.933,365.08 c0,70.827-58.027,128.853-128.853,128.853H144.92c-70.827,0-128.853-58.027-128.853-128.853V144.92 c0-70.827,58.027-128.853,128.853-128.853h220.16c70.827,0,128.853,58.027,128.853,128.853V365.08z" />
          <path d="M365.08,50.2H144.92c-52.053,0-94.72,42.667-94.72,94.72v220.16c0,52.053,42.667,94.72,94.72,94.72h220.16 c52.053,0,94.72-42.667,94.72-94.72V144.92C459.8,92.867,417.133,50.2,365.08,50.2z M442.733,365.08 c0,42.667-34.987,77.653-77.653,77.653H144.92c-42.667,0-77.653-34.987-77.653-77.653V144.92 c0-42.667,34.987-77.653,77.653-77.653h220.16c42.667,0,77.653,34.987,77.653,77.653V365.08z" />
          <path d="M255,118.467c-75.093,0-136.533,61.44-136.533,136.533S179.907,391.533,255,391.533S391.533,330.093,391.533,255 S330.093,118.467,255,118.467z M255,374.467c-65.707,0-119.467-53.76-119.467-119.467S189.293,135.533,255,135.533 S374.467,189.293,374.467,255S320.707,374.467,255,374.467z" />
          <path d="M255,161.133c-52.053,0-93.867,41.813-93.867,93.867c0,52.053,41.813,93.867,93.867,93.867s93.867-41.813,93.867-93.867 S307.053,161.133,255,161.133z M255,331.8c-42.667,0-76.8-34.133-76.8-76.8c0-42.667,34.133-76.8,76.8-76.8 c42.667,0,76.8,34.133,76.8,76.8C331.8,297.667,297.667,331.8,255,331.8z" />
          <path d="M391.533,92.867c-14.507,0-25.6,11.093-25.6,25.6s11.093,25.6,25.6,25.6c14.507,0,25.6-11.093,25.6-25.6 S406.04,92.867,391.533,92.867z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/InstagramSvg.js